import React, { Component } from "react";
import { Container, Grid, Icon } from "semantic-ui-react";

import MentionsLegales from "./MentionsLegales";

class Footer extends Component {
  render() {
    return (
      <footer>
        <Container>
          <Grid
            stackable
            columns={3}
            stretched
            style={{ color: "white" }}
            textAlign="center"
          >
            <Grid.Column>
              <p>
                <a
                  href="https://www.facebook.com/certytech/"
                  className="footer-link"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <Icon name="facebook square big" />
                </a>
              </p>
              <MentionsLegales />
            </Grid.Column>
            <Grid.Column>
              <a href="tel:0972543437" className="footer-link">
                <p>
                  <Icon name="phone big" />
                </p>
                <p>09 72 54 34 37</p>
              </a>
            </Grid.Column>
            <Grid.Column>
              <a href="mailto:contact@paraphe.online" className="footer-link">
                {" "}
                <p>
                  <Icon name="envelope big" />
                </p>
                <p>contact@paraphe.online</p>{" "}
              </a>
            </Grid.Column>
            <Grid.Column width="ten">
              <a
                href="https://certytech.com/"
                className="footer-link"
                target="_blank"
                rel="noopener noreferrer"
              >
                <p>Paraphe Online est un service proposé par Certytech</p>
              </a>
            </Grid.Column>
          </Grid>
        </Container>
      </footer>
    );
  }
}

export default Footer;



// WEBPACK FOOTER //
// ./src/components/Footer.js